<template lang="pug">
    model-form(
        ref='form'
        submit-text='guardar'
        title='Crear nomina de pago'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submitCreate'
    )
        template( slot='data-table-items' slot-scope='props' )
            v-btn( color='success' @click='submitAdd' ) agregar &nbsp;
                v-icon replay
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import SalarySettlementModel from '@/models/HumanResource/HrSalarySettlement'
    import PayrollModel from '@/models/HumanResource/HrPayroll'
    import PayrollFields from '@/views/HumanResource/HrPayroll/HrPayrollFields'
    //
    export default {
        name: 'payroll-create',
        components: {
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            formProps() {
                return {
                    fields: PayrollFields,
                }
            },

            /**
             * 
             */
            formFilter() {
                return {
                    can_be_added_to_payroll: true,
                    period_month: this.formData.payment_period_month,
                    period_year: this.formData.payment_period_year,
                }
            },

            /**
             * 
             */
            formParams() {
                return {
                    filter: this.formFilter,
                    get_all_results: true,
                }
            },
        },
        data() {
            return {
                formData: new PayrollModel({
                    selected: [],
                }),
            }
        },
        methods: {

            /**
             *
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             *
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * 
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(PayrollModel, error.response.data))
            },

            /**
             *
             */
            redirect() {
                this.$router.push({ name: 'payroll-list' })
            },

            /**
             *
             */
            reset() {
                this.formData.selected = []
            },

            /**
             * 
             */
            setFormDataSelected({ data }) {
                this.formData.selected = data
            },

            /**
             * 
             */
            submitAdd() {
                this.$refs.form
                    .setWait(true)
                    .then(this.toAdd)
                    .then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            submitCreate() {
                this.$refs.form
                    .setWait(true)
                    .then(this.toCreate)
                    .then(this.$refs.form.setWait)
            },

            /**
             *
             */
            successAdd() {
                this.setSuccessSnackbar('Liquidaciones de sueldo agregadas exitosamente.')
            },

            /**
             *
             */
            successCreate() {
                this.setSuccessSnackbar('Nomina de pago agregada exitosamente.')
            },

            /**
             * 
             */
            toAdd(model) {
                return SalarySettlementModel
                    .modeler()
                    .params(this.formParams)
                    .get()
                    .then(this.setFormDataSelected)
            },

            /**
             * 
             */
            toCreate(model) {
                return model
                    .toCreate()
                    .save()
                    .then(this.successCreate)
                    .then(this.redirect)
                    .catch(this.error)
            },
        },
        mounted() {
            this.setTitleTopBar('Crear nómina de sueldo')
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('CREATE_PAYROLL')) ctx.$router.push('/')
            })
        },
    }
</script>